'use client';
import './styles/@theme';
import { SvgLoader } from '@/app/elements/svg/loader';
import { getText } from '@/utils/text/text';
import { useEffect, useState } from 'react';
import { classes } from '@/utils/classes/classes';

type SmartBannerProps = {
    title: string;
    author: string;
    price: number;
    icon?: string;
    playStoreLink: string;
    openLinkAndroid: string;
};

type RelatedApp = { id: string };

export const SmartBannerClient = (props: SmartBannerProps) => {
    const { title, author, price, icon, openLinkAndroid, playStoreLink } = props;
    const [visible, setVisible] = useState(true);
    const [installed, setInstalled] = useState(false);

    const handleCTA = () => {
        window.location.href = installed ? openLinkAndroid : playStoreLink;
    };

    useEffect(() => {
        const nav = navigator as Navigator & {
            getInstalledRelatedApps?: () => Promise<RelatedApp[]>;
        };

        if (typeof nav.getInstalledRelatedApps === 'function') {
            nav.getInstalledRelatedApps()
                .then((apps) => setInstalled(apps?.length > 0))
                .catch((err) => console.error('Error fetching installed related apps:', err));
        }
    }, []);

    return (
        <div className={classes('smart-banner', !visible && 'closed')}>
            <div className="content">
                <button className="close-button" onClick={() => setVisible(false)}>
                    <SvgLoader iconName="close" width="16" height="16" />
                </button>
                {icon && <img src={icon} alt="App Icon" width={46} height={46} />}
                <div className="description">
                    <div className="title">{title}</div>
                    <div className="author">{author}</div>
                    <div className="price">{installed ? 'INSTALLED' : `GET ${price}`}</div>
                </div>
            </div>
            <div className="cta">
                <button className="cta-button primary-button" onClick={handleCTA}>
                    <p>{getText({ text: installed ? 'common.open' : 'common.view' })}</p>
                </button>
            </div>
        </div>
    );
};
